/* eslint-disable */
import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { login, getCachedUser } from 'lib/network/webapi';
import _debug from 'debug';
import { AdminScreen } from './components';
import {
    App,
    NotFound,
    LogOut,
    Home
  } from './containers';

const debug = _debug('app:routes');
export default (store) => {
  function requireLogin(nextState, replace, cb) {
    debug('store', store);
    if (!__MANAGE__ || __CONFIG__.testManageApp) {
      if (nextState.location.pathname === '/') {
        if (getCachedUser()) {
          debug(nextState);
          cb();
        } else {
          login();
        }
      } else {
        cb();
      }
    } else {
      cb();
    }
  }
  return (
    <Route path="/" component={App}>
      <IndexRoute component={Home} onEnter={requireLogin} />
      <Route path="home" component={Home} onEnter={requireLogin} />
      <Route path="admin" component={AdminScreen} onEnter={requireLogin} />
      {/* Catch all route */}
      <Route path="loggedOut" component={LogOut} />
      <Route path="*" component={NotFound} status={404} />
    </Route>
  );
};



// WEBPACK FOOTER //
// ./src/routes.js